import { Component, ElementRef, EventEmitter, Input, OnInit, Optional, Output, Self, ViewChild } from '@angular/core';
import { ControlValueAccessor, NgControl, FormControl, FormGroupDirective } from '@angular/forms';

@Component({
    selector: 'superflex-input-mask',
    template: `
        <label for="controltext"> {{ label }} <span *ngIf="ngControl.control.errors?.required" style="font-weight: 900;">*</span> </label>
        <p-inputMask
            [mask]="mask"
            [placeholder]="placeholder"
            (onBlur)="onInput($event.target.value)"
            (blur)="onInputBlur($event)"
            [disabled]="isDisabled"
            [class.ng-invalid]="ngControl.control.invalid"
            [class.ng-dirty]="ngControl.control.dirty"
            [class.ng-touched]='ngControl.control.touched'
            [class.ng-untouched]='ngControl.control.untouched'
            [class.ng-pristine]='ngControl.control.pristine'
        ></p-inputMask>
        <app-error [input]="ngControl.control" [form]="form" class="p-error" ></app-error>
    `,
    styleUrls: ['./input-mask.component.scss'],
    host: { 'class': 'p-field' },
})
export class InputMaskComponent implements OnInit, ControlValueAccessor {

    public checked: boolean;
    public focused: boolean;

    inputControl: FormControl = new FormControl(null);

    @Input() isDisabled: boolean = false;
    @Input() type: string = 'text';
    @Input() label: string = '';

    currentValue: any = null;
    onChange = (_: any) => {/** */ };
    onTouch = () => {/** */ };

    @Input() mask = "";
    @Input() placeholder = '';
    @ViewChild('rb') inputViewChild: ElementRef;

    @Output() onFocus: EventEmitter<any> = new EventEmitter();
    @Output() onBlur: EventEmitter<any> = new EventEmitter();

    form!: FormGroupDirective;

    constructor(@Self() @Optional() public ngControl: NgControl, private rootFormGroup: FormGroupDirective) {

        this.form = this.rootFormGroup;
        if (this.ngControl) {
            ngControl.valueAccessor = this
        }
    }

    ngOnInit(): void {/** */ }

    onInput(value: any) {
        this.currentValue = value
        this.onTouch();
        this.onChange(this.currentValue)
    }

    writeValue(value: any): void {
        if (value) {
            this.currentValue = value
        } else {
            this.currentValue = null
        }
    }

    registerOnChange(fn: any): void {
        this.onChange = fn
    }
    registerOnTouched(fn: any): void {
        this.onTouch = fn
    }
    setDisabledState?(isDisabled: boolean): void {
        this.isDisabled = isDisabled
    }

    onInputFocus(event): void {
        this.focused = true;
        this.onFocus.emit(event);
    }

    onInputBlur(event): void {
        this.focused = false;
        this.onModelTouched();
        this.onBlur.emit(event);
    }

    onModelTouched = () => {
    };

    focus(): void {
        this.inputViewChild.nativeElement.focus();
    }

    ngOnDestroy(): void {
        // this.registry.remove(this);
    }

    getPlaceholderPrefix(): string {
        return this.isDisabled ? '' : 'FORM_ERRORS.placeholder';
    }


}
